import { ACTION_STATUS } from '../actions/types'
import type { MeetingManagementQuery } from '../meetingManagement/types'

/** Ekranın sekmeleri — adresteki `?tab=` değeri (research D7). Sıra sabittir: indeks ↔ sekme. */
export const APPROVALS_TAB = {
  REQUESTS: 'requests',
  TASKS: 'tasks',
} as const

export type ApprovalsTab = (typeof APPROVALS_TAB)[keyof typeof APPROVALS_TAB]

export const APPROVALS_TABS: ApprovalsTab[] = [APPROVALS_TAB.REQUESTS, APPROVALS_TAB.TASKS]

/**
 * Görev Kapatma sekmesinin **sabit** sorgusu (131 FR-013/FR-015): yalnız Onay Bekleniyor (331)
 * statüsündeki **ana** görevler, toplantıya bağlı olsun olmasın. Süzgeç yoktur (kullanıcı kararı) —
 * sekmenin listesi ile başlığındaki sayı bu tek tanımdan beslenir, ikisi ayrışamaz.
 */
export const TASK_CLOSURE_QUERY: Pick<
  MeetingManagementQuery,
  'statusIds' | 'includeDirectTasks' | 'includeSubTasks'
> = {
  statusIds: [ACTION_STATUS.COMPLETED],
  includeDirectTasks: true,
  includeSubTasks: false,
}

/**
 * Açılış sırası: **en uzun süredir onay bekleyen en üstte** (131 FR-015) — görevin 331'e girdiği ana
 * göre artan. Kullanıcı bir kolonu sıraladığında o geçerli olur; sıralamayı kaldırdığında bu düzene
 * döner (Toplantı Yönetimi'nin "en geciken üstte" varsayılanına değil).
 */
export const TASK_CLOSURE_DEFAULT_SORT = 'completedAt,asc'

/** Kuyruk listelerinin sayfa boyutu (anayasa: tüm listelerde varsayılan 10). */
export const APPROVALS_PAGE_SIZE = 10
